.disabled {
  opacity: 0.5;
  pointer-events: none;
}

gz-info-box {
  padding: calc(var(--spacer) * 2) 0;
}

gz-dropdown {
  --form-field-input-width: 400px;
}

gz-title + gz-form-field,
gz-title + gz-labeled-content {
  padding-top: 15px;
}

.form-field-info-text {
  padding-left: calc(var(--spacer) * 3.3);
  padding-top: calc(var(--spacer) * 2);
}

gz-complex-enum-list {
  border: 1px solid var(--chart-100-pressed);
  border-radius: 5px;
  width: 649px;
}

.flex {
  display: flex;
}

.custom-mt {
  margin-top: calc(var(--spacer) * 2);
}

.small-label-width {
  --form-field-label-width: 125px;
}

#directly-connected-remote-mac-field {
  --form-field-label-width: 210px;
}

gz-radio-group {
  display: flex;
}

.small-dropdown-width {
  --form-field-input-width: 200px;
}
.radio {
  display: flex;
  z-index: 2;
}

gz-radio {
  z-index: 1;
}

gz-labeled-content {
  &::part(content) {
    overflow: visible;
  }
}

.dropdown-field-inside-radio {
  --margin-bottom-wrapper: 0px;
  margin-top: -5px;
}

gz-checkbox {
  width: auto;
}
